import { statisticsDataMock } from '../../mocks/statistics-all-data.mock';

export const statisticsDataMapped = statisticsDataMock.data.map(x => {
  const keyValueEntries: Record<string, unknown> = { date: x.date };

  x.entries.forEach(e => {
    keyValueEntries[e.name] = e.value;
  });

  return { ...keyValueEntries };
});
